import {
  AppBar,
  Badge,
  Button,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Toolbar,
  Typography,
  Slide,
  InputBase,
  Popover,
  Grid,
  Card,
  CardContent,
  Backdrop,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CardActions,
  Divider
} from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import NotificationsPopover from 'src/components/NotificationsPopover';
import SearchPopover from 'src/components/SearchPopover';
import SelectLanguage from 'src/components/SelectLanguage';
import { initNotifications } from 'src/modules/Notifications';
import { getNotifications, notifyNotificationViewed, readNotifications } from 'src/store/api/notificationsApi';
import { handleLogoutMain, publishLocation, getUser } from 'src/utils/Common';
import { baseURL, pushServerPublicKey } from 'src/utils/contants';
import { closeAlert, getTasksRequest } from '../../store/actions';
import { Link as RouterLink } from 'react-router-dom';
import { fade } from '@material-ui/core/styles';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import SearchIcon from '@material-ui/icons/Search';
import CallEndIcon from '@material-ui/icons/CallEnd';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PersonIcon from '@material-ui/icons/Person';
import axios from 'src/utils/axios';
import Flag from 'react-world-flags';
import { useOktaAuth } from '@okta/okta-react';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  table: {
    minWidth: 600
  },
  flexGrow: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.55),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.65)
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '70ch',
      '&:focus': {
        width: '70ch'
      }
    }
  },
  SearchDiv: {
    minWidth: 600,
    minHeight: 370
  },
  SearchDivForThreeChar: {
    minWidth: 600,
    minHeight: 40
  }
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const DefaultAddress = [
  {
    AddressType: '',
    Address: '',
    State: '',
    AddressItem: '',
    Apartment: '',
    City: '',
    District: '',
    DoorNr: '',
    Latitude: 0,
    Longitude: 0,
    Neighborhood: '',
    PostCode: '',
    Region: '',
    Street: '',
    PrimaryAddress: true,
    AddressTypeId: 0,
    AddressId: 0
  }
];
function TopBar({
  onOpenNavBar,
  className,
  getTasksRequest,
  alertReducer,
  closeAlert
}) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const history = useHistory();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationsLenght, setNotificationsLenght] = useState(0);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [Search, setSearch] = useState('');
  const [MenuShow, setMenuShow] = useState(false);
  const [SearchData, setSearchData] = React.useState([]);
  const [loading, setloading] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [CountryPopup, setCountryPopup] = useState(false);
  const [TenantData, setTenantData] = useState([]);
  const SessionUser = getUser();

  const isAppSystemControl = process.env.REACT_APP_SYSTEM;

  console.log("Topbar rendered")



  // var ImageApp = "";
  // if (SessionUser.Role === 1) {
  //   ImageApp = "/images/LogoPartner.png"
  // }
  // if (SessionUser.Role === 2) {
  //   ImageApp = "/images/LogoPartner.png"
  // }
  // if (SessionUser.Role === 3) {
  //   ImageApp = "/images/LogoCrm.png"
  // }
  // if (SessionUser.Role === 4) {
  //   ImageApp = "/images/LogoPortal.png"
  // }
  // if (SessionUser.Role === 5) {
  //   ImageApp = "/images/LogoAdmin.png"
  // }

  const { oktaAuth } = useOktaAuth();
  const [openWarning, setopenWarning] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [imageControl, setimageControl] = React.useState("/images/LogoPartner.png");

  const Logout = async () => {
    handleLogoutMain();
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    // oktaAuth.tokenManager.clear();
    // window.location.href = window.location.origin;
    await oktaAuth.signOut();
  };

  const ReadNotifications = () => {
    setShowNotificationList(false)
    const maxId = Math.max(...notifications.map(o => o.Id))
    readNotifications(SessionUser.TechnicianId, maxId);
    if (notifications !== undefined && notifications.length > 0) {
      const updatedList = notifications.map(n => {
        if (n.IsRead === false) {
          return { ...n, IsRead: true };
        }
        return n;
      });
      setNotifications(updatedList);
    }
    setNotificationsLenght(0);
  }

  const FetchNotifications = async () => {
    // get all new notifications from server
    getNotifications(SessionUser.TechnicianId)
      .then(res => {
        if (res.data.length > 0) {
          setNotifications(res.data);
          const unreadItems = res.data.filter(item => item.IsRead === false);
          setNotificationsLenght(unreadItems.length)
        }
      })
      .catch(error => console.error(error));
  }

  useEffect(() => {
    FetchNotifications()
  }, []);

  useEffect(() => {
    // Component ilk kez yüklendiğinde ve her 5 dkda bir API'ye istek gönderme
    FetchNotifications();
    const intervalId = setInterval(FetchNotifications, 180000);

    // Component temizlendiğinde interval'i kaldırma
    return () => {
      clearInterval(intervalId);
    };
  }, []);


  const handleClickNotification = ({ ID, Url }) => {
    setShowNotificationList(false);
    // notify server that was read
    notifyNotificationViewed(ID);
    getTasksRequest();
    if (Url.match(baseURL)) {
      history.push(Url.replace(baseURL, ''));
    } else {
      window.open(Url, '_blank');
    }
    // remove clicked notification
    setNotifications(notifications =>
      notifications.filter(notification => notification.ID !== ID)
    );
  };
  const listenServiceWorker = () => {
    navigator.serviceWorker.addEventListener('message', event => {
      const { notification } = event.data;
      // add to notification list if new notification
      if (notification.action === 'ADD') {
        setNotifications(notifications => [notification, ...notifications]);
      }
      // delete if user redirected from device notifications
      if (notification.action === 'DELETE' && notification.ID) {
        // in this case notified server by service worker
        setNotifications(notifications =>
          notifications.filter(ntf => ntf.ID !== notification.ID)
        );
      }

      if (notification.action === 'MUSTERI_IZLIYOR' && notification.ID) {
        setInterval(() => {
          publishLocation(notification.Title || 1);
        }, 10000);
      }
    });
  };
  const handleDeleteAll = () => {
    setShowNotificationList(false);
    confirmAlert({
      message: t('bildirim_sil_confirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => deleteYes()
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
    const deleteYes = () => {
      notifications.forEach(e => {
        notifyNotificationViewed(e.ID);
      });
      // getNotifications()
      //   .then(res => {
      //     res.data && setNotifications(res.data);
      //   })
      //   .catch(error => console.error(error));
    };
  };
  const Beyaz = {
    color: '#FFFFFF'
  };
  const setMenuShowFnc = () => {
    if (MenuShow) {
      setMenuShow(false);
    } else {
      setMenuShow(true);
    }
    onOpenNavBar();
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const setLocalWorkCaseSearchResult = event => {

    setSearchData([]);
    setloading(true);
    if (Search.length > 0) {
      axios
        .get(
          '/GetSearchMain/2/' +
          Search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)
        )
        .then(res => {
          const response = res.data;
          setloading(false);
          setSearchData(response);
          setLocalSearhResult("", response[0]);
        })
        .catch(err => {
          setSearchData([]);
          setloading(false);
        });
    }
  };


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {

      if (Search.length > 7) {
        axios
          .get(
            '/GetSearchMainWithoutNameAndLimitedPhone/1/' +
            Search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)
          )
          .then(res => {
            const response = res.data;
            setloading(false);
            setSearchData(response);
          })
          .catch(err => {
            setSearchData([]);
            setloading(false);
          });
      }
      else if (Search.length > 2) {
        setloading(true);
        axios
          .get(
            '/GetSearchMain/1/' + encodeURIComponent(Search.toString()) + "/partner"
          )
          .then(res => {
            const response = res.data;
            setloading(false);
            setSearchData(response);
          })
          .catch(err => {
            setSearchData([]);
            setloading(false);
          });
      }


    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [Search])

  const setSearchFind = event => {
    setSearch(event.target.value);
    setSearchData([]);
    setloading(true);

  };
  const setLocalSearhResult = (event, item) => {
    if (item.Addresses === undefined) {
      item.Addresses = DefaultAddress;
    }
    sessionStorage.removeItem('SearhResult');
    sessionStorage.setItem('SearhResult', JSON.stringify(item));
    sessionStorage.removeItem('ConsumerId');
    sessionStorage.setItem('ConsumerId', item.ConsumerId);
    history.push('/overview');
    handleClose();
    setSearch('');
  };
  const setLocalContentSearh = event => {
    sessionStorage.removeItem('SearhContentSearchParam');
    sessionStorage.setItem('SearhContentSearchParam', Search);
    history.push('/Bultenler');
    handleClose();
    setSearch('');
  };

  const setLocalWorkOrderSearchResult = (event, item) => {

    if (isNaN(Search)) {
      const informationAlert = t('Fis_Bulunamadi').replace('@FisNo', Search);
      setUyari(informationAlert);
      setopenWarning(true);
      return;
    }
    axios
      .get('/GetConsumerByWorkOrderId/' + Search + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(res => {
        const response = JSON.stringify(res.data[0]);
        if (response === undefined) {
          const informationAlert = t('Fis_Bulunamadi').replace('@FisNo', Search);
          setUyari(informationAlert);
          setopenWarning(true);
        } else {
          sessionStorage.removeItem('SearhResult');
          sessionStorage.setItem('SearhResult', response);
          sessionStorage.removeItem('ConsumerId');
          sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
          getTasksRequest(Search);
          history.push(`/WorkOrder/${Search}/summary`);
        }

      })
      .catch(err => { });

  };

  const setLocalNewCustomerSearchResult = (event) => {
    if (isNaN(Search)) {
      const informationAlert = t('lblWarningMustPhone');
      setUyari(informationAlert);
      setopenWarning(true);
      return;
    }

    sessionStorage.removeItem('AddNewCustomer');
    sessionStorage.setItem('AddNewCustomer', Search);
    history.push('/overview');
    handleClose();
    setSearch('');


  }

  const fncsetCountryChange = () => {
    setloading(true);
    axios
      .get('/GetTenantMapData')
      .then(res => {
        const response = res.data;
        setloading(false);
        var sortedTenantMapData = response.sort((a, b) => a.Tenant.localeCompare(b.Tenant))
        setTenantData(sortedTenantMapData);
        setCountryPopup(true);
      })
      .catch(err => {
        setTenantData([]);
        setloading(false);
      });
  };

  const changeCountry = country => {
    setCountryPopup(false);
    confirmAlert({
      message: t('ChangingCoutryQuestion'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => changeCountryYes(country)
        },
        {
          label: t('Hayir'),
          onClick: () => {
            setCountryPopup(true);
          }
        }
      ]
    });
  };

  const changeCountryYes = country => {
    const data = {
      TechnicianId: SessionUser.TechnicianId,
      TenantId: country.TenantId,
      TenantCode: country.CountryCode
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/ChangeCountry', data, config)
      .then(response => {
        handleLogoutMain();
        sessionStorage.removeItem('SearhResult');
        sessionStorage.removeItem('ConsumerId');
        window.location.href = window.location.origin;
      })
      .catch(error => { });
  };

  const handleEnterKey = (e) => {

    if ((localStorage.getItem('i18nextLng') === "zh-TW") || (localStorage.getItem('i18nextLng') == "zh-CN") || (localStorage.getItem('i18nextLng') == "zh-Chs")) {

      if (e.nativeEvent.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(e.currentTarget)
      }
    }
    else {
      setAnchorEl(e.currentTarget);
    }
  }

  return (
    <AppBar
      className={clsx(classes.root, className)}
      style={{ background: '#1D3343' }}
    >
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={setMenuShowFnc}
          data-tour="OpenNavbarButton"
        >
          {MenuShow ? <MenuIcon /> : <MenuOpenIcon />}
        </IconButton>
        <RouterLink to="/overview" data-tour="SiriusButton">
          <img
            height="55px"
            alt="Logo"
            src={imageControl} />
        </RouterLink>
        <Typography variant="h6" className={classes.title} />
        {SessionUser.ServiceShopTypeId !== 16 && SessionUser.ServiceShopTypeId !== 18 && !(SessionUser.ServiceShopTypeId === 15 && SessionUser.TenantId === 118) && (
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder={t('lblGlobalSearch')}
              autoFocus={true}
              value={Search}
              onKeyUp={handleEnterKey}
              onChange={event => setSearchFind(event)}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput
              }}
              inputProps={{ 'aria-label': 'search', autoFocus: true }}
            />
            <Popover
              disableAutoFocus
              onKeyDown={handleClose}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              <Card className={clsx(classes.root, className)}>
                {Search.length < 3 ? (
                  <CardContent className={classes.SearchDivForThreeChar}>
                    <Typography
                      className={classes.typography}
                      style={{ textAlign: 'center' }}
                    >
                      {t('Lütfen aramak için üç karakter girin.')}
                    </Typography>
                  </CardContent>
                ) : SearchData.length == 0 ? (
                  <CardContent className={classes.SearchDivForThreeChar}>
                    {loading ? (
                      <CircularProgress
                        status="loading"
                        style={{ marginLeft: '50%' }}
                      />
                    ) : (
                      <Typography
                        className={classes.typography}
                        style={{ textAlign: 'center' }}
                      >
                        {t('Aradığınız sonuç bulunmamaktadır.')}
                      </Typography>
                    )}
                  </CardContent>
                ) : (
                  <CardContent className={classes.SearchDiv}>
                    {SearchData.map(option => (
                      <List
                        key={option.SearchId}
                        onClick={event => setLocalSearhResult(event, option)}
                      >
                        <ListItem button>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={2} align="left">
                              <Typography
                                variant="caption"
                                display="block"
                                gutterBottom
                              >
                                {option.SearchId}
                              </Typography>
                              <PersonIcon fontSize="small" />
                              <Typography variant="h6" gutterBottom>
                                {option.Search}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={5} align="left">
                              <Grid item>
                                <CallEndIcon fontSize="small" />
                              </Grid>
                              {option.Phones?.map((item, index) => (
                                <Typography
                                  variant="body2"
                                  display="block"
                                  key={index}
                                >
                                  {item.Phone + '  ' + item.PhoneType}
                                </Typography>
                              ))}
                            </Grid>
                            <Grid item xs={12} sm={5} align="left">
                              <Grid item>
                                <LocationOnIcon fontSize="small" />
                              </Grid>
                              {option.Addresses?.map((item, index) => (
                                <Typography
                                  variant="body2"
                                  display="block"
                                  key={index}
                                >
                                  {item.AddressType + '  ' + item.Address}
                                </Typography>
                              ))}
                            </Grid>
                          </Grid>
                        </ListItem>
                      </List>
                    ))}
                  </CardContent>
                )}
                <CardActions>
                  <Button
                    size="small"
                    onClick={event => setLocalContentSearh(event)}
                    color="primary"
                  >
                    {t('ContentGlobalSearch')}
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Button
                    size="small"
                    onClick={event => setLocalWorkOrderSearchResult(event)}
                    color="primary"
                  >
                    {t('WorkOrderGlobalSearch')}
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Button
                    size="small"
                    onClick={event => setLocalWorkCaseSearchResult(event)}
                    color="primary"
                  >
                    {t('WorkCaseGlobalSearch')}
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Button
                    size="small"
                    onClick={event => setLocalNewCustomerSearchResult(event)}
                    color="primary"
                  >
                    {t('lblNewCustomer')}
                  </Button>
                </CardActions>
              </Card>
            </Popover>
          </div>
        )}
        <Typography variant="h6" className={classes.title} />
        <IconButton
          className={classes.iconButton}
          onClick={fncsetCountryChange}
        >
          <Badge style={Beyaz}>
            <Typography style={Beyaz}>{SessionUser.Tenant}</Typography>
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={fncsetCountryChange}
        >
          <Badge style={Beyaz}>
            <Flag code={SessionUser.TenantCode} height="16" />
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={() => setShowNotificationList(true)}
          ref={notificationsRef}
        >
          <Badge style={Beyaz} badgeContent={notificationsLenght}>
            <NotificationsActiveIcon style={{ color: 'white' }} />
          </Badge>
        </IconButton>
        <SelectLanguage />
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={() => Logout()}
          data-tour="LogoutButton"
        >
          <ExitToAppIcon style={{ color: 'white' }} />
        </IconButton>
      </Toolbar>

      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClose={() => ReadNotifications()}
        open={showNotificationList}
        handleDeleteAll={handleDeleteAll}
      />

      <Dialog open={alertReducer.open} onClose={() => closeAlert()}>
        <DialogTitle color="primary">{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{alertReducer.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeAlert()} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={CountryPopup}
        maxWidth="xs"
        fullWidth
        onClose={() => setCountryPopup(false)}
      >
        <DialogTitle color="primary">{t('lblChangeCountry')}</DialogTitle>
        <DialogContent dividers>
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {TenantData.map(item => (
              <ListItem
                button
                key={item.TenantId}
                onClick={() => changeCountry(item)}
              >
                <ListItemIcon>
                  <Flag code={item.CountryCode} height="16" />
                </ListItemIcon>
                <ListItemText primary={` ${item.Tenant}`} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCountryPopup(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openWarning}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setopenWarning(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>


      <div style={{ position: 'absolute', bottom: 0, right: 20, fontSize: 15 }}>
        {isAppSystemControl}
      </div>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBar: PropTypes.func
};

export default connect(state => ({ alertReducer: state.alertReducer }), {
  getTasksRequest,
  closeAlert
})(TopBar);
